import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import LocalizationProvider from './components/LocalizationProvider';
import { locales } from './components/LocaleProvider';

import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
  const getEnvironment = () => {
    const hostname = window.location.hostname;
    if (hostname === 'care.testing.ospitek.com') return ['Testing', 1.0];
    if (hostname.startsWith('care.view') && hostname.endsWith('.ospitek.com')) {
      const instance = hostname.replace('care.', '').replace('.ospitek.com', '');
      return [instance.charAt(0).toUpperCase() + instance.slice(1), 0.1];
    }
    if (hostname === 'care.ospitek.com') return ['View', 0.1];
    return null;
  };

  const env = getEnvironment();
  if (env) {
    const [environment, tracesSampleRate] = env;
    Sentry.init({
      dsn: 'https://cd63409cd0294ccbb44e3b1182fae586@o1065753.ingest.sentry.io/6057910',
      environment,
      tracesSampleRate,
      integrations: [new Integrations.BrowserTracing()],
    });
  }
}

if (process.env.NODE_ENV === 'development') {
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <LocalizationProvider locales={locales}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </LocalizationProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
